import React, { useEffect } from "react";
import { MdKeyboardArrowLeft, MdEast } from "react-icons/md";
import {
  Image,
  Container,
  Col,
  Row,
  Button,
  InputGroup,
} from "react-bootstrap";
import AllMessages from "./AllMessages";
import ChatBox from "./ChatBox";
import PrivacyTermsConditions from "../../Components/PrivacyTermsConditions/PrivacyTermsConditions";
import { Link, NavLink, useParams } from "react-router-dom";
import { useState } from "react";
import SideBar from "../SideBar/SideBar";
import BackButton from "../BackButton/BackButton";

const Messages = (props) => {
  const [toggleChat, setToggleChat] = useState(false);

  const routeParams = useParams();

  const flagFetchHandler = (flag) => {
    setToggleChat(flag);
  };

  return (
    <>
      <div className="gray-bg">
        <div className="navbar-section p-0">
          <SideBar />
        </div>
        <div className="main-content pt-5 pr-3 pb-4">
          <BackButton />
          <p className="page-maintitle">Messages</p>
          <Row>
            <Col md="6">
              <AllMessages
                FlagFetchHandler={flagFetchHandler}
                selectedChannel={routeParams}
              />
            </Col>
            <Col md="6">
              <ChatBox ToggleChat={toggleChat} selectedChannel={routeParams} />
            </Col>
          </Row>
        </div>
      </div>
      <PrivacyTermsConditions />
    </>
  );
};

export default Messages;
